export const SELECTORS = {
  LIST: 'js-product-card-options-list',
  OPTION: 'js-product-card-option'
};
